import React, { useState, useEffect, useRef } from 'react';
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Typography from "@material-ui/core/Typography";
import { Link, useHistory } from "react-router-dom";
import { Button, IconButton, Tooltip } from '@material-ui/core';
import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Business from '@material-ui/icons/Business';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import GroupIcon from '@material-ui/icons/Group';
import makeStyles from "@material-ui/core/styles/makeStyles";
import auth from "./Authenticate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileAlt,
    faEye,
    faBuilding,
    faEnvelope,
    faUsers,
    faTools,
    faKey,
    faUnlock,
    faPlug,
    faCoins
} from '@fortawesome/free-solid-svg-icons'
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import MessageIcon from '@material-ui/icons/Message';
import { userMessageService } from "./_services/userMessage.service";
import SocketContext from '@SocketContext'
import { skip } from "rxjs/internal/operators/skip";
import { useUserMode } from "@UserModeContext";
import backgroundRed from '../assets/images/backgrounds/bg_navbar_red.png';
import backgroundBlue from '../assets/images/backgrounds/bg_navbar_blue.jpg';
import { withStyles } from "@material-ui/core/styles";
import EqsmLogo from "../assets/images/logos/eqsm_logo.svg";
import EditModeTree from "../assets/images/icons/edit-mode-tree.svg"
import UserModeTree from "../assets/images/icons/user-mode-tree.svg"
import UserProcesses from "../assets/images/icons/user-processes.svg"
import UserDocuments from "../assets/images/icons/user-documents.svg"
import PasswordChangeDialogComponent from '../Pages/PasswordManagmentPage/PasswordChangeDialogComponent';
import { useCookies } from 'react-cookie';
import { checkRolesPermissions } from '../Helpers/PagesPermissions/RolesPermissionsParser';
import { MessagesPagePermissions, PasswordManagmentPagePermissions, UsersPagePermissions } from '../Helpers/PagesPermissions/pagesPermissions';


const useStyles = makeStyles(theme => ({
    appBarRoot: {
        boxShadow: "none",
        zIndex: theme.zIndex.drawer + 1 + "!important",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
    },
    appBarRoot_RED: {
        background: "url(" + backgroundRed + ") !important",
    },
    appBarRoot_BLUE: {
        background: "url(" + backgroundBlue + ") !important",
    },
    appBarIcon: {
        marginRight: theme.spacing(1),
        height: "40px"
    },
    appBarTitleContainer: {
        marginRight: theme.spacing(2),
        ['@media (max-width:840px)']: { 
            display: 'none'
        }
    },
    appBarTitle: {
        paddingTop: theme.spacing(0.5),
        lineHeight: theme.spacing(0.1)
    },
    appBarLink: {
        color: '#ffffff',
        textDecoration: 'none',
        display: 'flex'
    },
    avatar: {
        cursor: 'pointer',
        margin: theme.spacing(1),
        height: '32px',
        width: '32px'
    },
    badge: {
        cursor: 'pointer',
        margin: theme.spacing(1)
    },
    imageIcon: {
        height: '100%'
    },
    iconRoot: {
        textAlign: 'center',
        color: '#ffffff!important'
    },
    st0: {
        fill: '#fff',
        stroke: '#fff',
        strokeMiterlimit: 10
    },
    st1: {
        fill: '#fff'
    },
    st2: {
        fill: '#fff'
    },
    st3: {
        fill: 'none',
        stroke: '#fff',
        strokeWidth: 17,
        strokeMiterlimit: 10
    },
    navBarButton: {
        // backgroundColor: 'green',
        borderLeft: '1px solid white',
        borderRadius: 0,
        height: '35%',
        padding: '0.2% 1%',
        '&:last-of-type': {
            borderRight: '1px solid white',
        }
    },
    customMenuIcon: {
        width: '24px',
        height: '24px',
    },
    buttonLink: {
        height: '36px'
    },
    buttonLinkContainer: {
        paddingLeft: '20px',
        ['@media (max-width:920px)']: { 
            "& > span": {
                display: 'none'
            },
            paddingLeft: '5px',

        }
    }
}));
const CustomToolBar = withStyles({
    root: {
        minHeight: '30px !important'
    },
})(Toolbar);
const NaviBar = (props) => {
    const { socket } = props;
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorAdminMenuEl, setAnchorAdminMenuEl] = useState(null);
    const [anchorPluginMenuEl, setAnchorPluginMenuEl] = useState(null);
    const [anchorUserMenuEl, setAnchorUserMenuEl] = useState(null);
    const [messageCounter, setMessageCounter] = useState(0);
    const [plugins, setPlugins] = useState([]);
    const history = useHistory();
    const userModeState = useUserMode();
    const changePasswordDialogRef = useRef();
    const [, setCookie] = useCookies();

    useEffect(() => {
        let cAd = 0;
        let cBus = 0;
        let cSys = 0;


        const adSubscription = userMessageService.getAdMessageCounterMessage().pipe(skip(1)).subscribe(m => {
            cAd = m.counter;
            setMessageCounter(cAd + cBus + cSys);
        });
        const busSubscription = userMessageService.getBusMessageCounterMessage().pipe(skip(1)).subscribe(m => {
            cBus = m.counter;
            setMessageCounter(cAd + cBus + cSys);
        });
        const sysSubscription = userMessageService.getSysMessageCounterMessage().pipe(skip(1)).subscribe(m => {
            cSys = m.counter;
            setMessageCounter(cAd + cBus + cSys);
        });

        return () => {
            adSubscription.unsubscribe();
            busSubscription.unsubscribe();
            sysSubscription.unsubscribe();
        }
    }, []);

    useEffect(() => {
        sessionStorage.getItem('plugins') && setPlugins(JSON.parse(sessionStorage.getItem('plugins')));
    },[sessionStorage.getItem('plugins')])

    useEffect(() => {
        auth.hasToChangePassword() && changePasswordDialogRef.current.openDialog('Twoje hasło wygasło', true);
    }, [changePasswordDialogRef])



    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAdminMenuClick = event => {
        setAnchorAdminMenuEl(event.currentTarget);
    };

    const handleCloseAdminMenu = () => {
        setAnchorAdminMenuEl(null);
    };

    const handleUserMenuClick = event => {
        setAnchorUserMenuEl(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorUserMenuEl(null);
    };

    const handlePluginMenuClick = event => {
        setAnchorPluginMenuEl(event.currentTarget);
    };

    const handleClosePluginMenu = () => {
        setAnchorPluginMenuEl(null);
    };

    const openMessageComponent = event => {
        userMessageService.drawerComponentMessage({ open: true });
    };

    const handleLogout = () => {
        socket.emit('unregister-user', { username: auth.getUserName() }, (ack) => {
            console.log(ack);
        });
        auth.logout();
        history.push('/login');
    };

    const handleUserMode = () => {
        userModeState.toggle();
        handleCloseUserMenu();
    };
    const handleChangePassword = () => {
        changePasswordDialogRef.current.openDialog();
        handleCloseUserMenu();
    };

    const handleEditModeTree = () => {
        if (userModeState.userMode === true) {
            userModeState.toggle();
        }
        setCookie('documentsPanel', 'documents', { path: '/' });
        history.push({
            pathname: "/dokumenty",
        });
    }

    const handleUserModeTree = () => {
        if (userModeState.userMode === false) {
            userModeState.toggle();
        }
        setCookie('documentsROPanel', 'documents', { path: '/' });        
        history.push({
            pathname: "/dokumenty",
        });
    }

    const handleUserProcesses = () => {
        if (userModeState.userMode === false) {
            userModeState.toggle();
        }
        setCookie('documentsROPanel', 'processes', { path: '/' });        
        history.push({
            pathname: "/dokumenty",
        });
    }

    const handleUserDocuments = () => {
        if (userModeState.userMode === false) {
            userModeState.toggle();
        }
        setCookie('documentsROPanel', 'tasks', { path: '/' });        
        history.push({
            pathname: "/dokumenty",
        });
    }

    return (
        <>
            <AppBar position="relative" className={classes.appBarRoot + ` ` + (userModeState.userMode === false ? classes.appBarRoot_RED : classes.appBarRoot_BLUE)}>
                <CustomToolBar>
                    <Link color="inherit" to={auth.getUserRole('G_ADMIN') === 'G_ADMIN' ? "/zarzadzanie-firmami" : "/"} rel="noopener" className={classes.appBarLink}>
                        <img src={EqsmLogo} className={classes.appBarIcon} alt="" />
                        <Box component="div" className={classes.appBarTitleContainer}>
                            <Typography color="inherit" className={classes.appBarTitle} noWrap>
                                EQSM6
                            </Typography>
                            <small>wersja: 6.1.8</small>
                        </Box>
                    </Link>
                    {auth.getUserRole('G_ADMIN') !== "G_ADMIN" && (
                        <>
                            <Button
                                className={classes.navBarButton}
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                color="inherit"
                                onClick={handleClick}
                            >
                                Organizacja
                            </Button>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                getContentAnchorEl={null}
                                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                transformOrigin={{ vertical: "top", horizontal: "center" }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleClose} component={Link} to="/struktura-organizacyjna">
                                    <ListItemIcon>
                                        <Business />
                                    </ListItemIcon>
                                    <ListItemText primary="Struktura organizacyjna" />
                                </MenuItem>
                                {userModeState.userMode === false && <MenuItem onClick={handleClose} component={Link} to="/edycja-dokumentow">
                                    <ListItemIcon>
                                        <FontAwesomeIcon aria-label={"Documents"} icon={faFileAlt} />
                                    </ListItemIcon>
                                    <ListItemText primary="Edycja dokumentów" />
                                </MenuItem>}
                                {userModeState.userMode === true && <MenuItem onClick={handleClose} component={Link} to="/dokumenty">
                                    <ListItemIcon>
                                        <FontAwesomeIcon aria-label={"Documents"} icon={faFileAlt} />
                                    </ListItemIcon>
                                    <ListItemText primary="Dokumenty" />
                                </MenuItem>}
                                {userModeState.userMode === false && <MenuItem onClick={handleClose} component={Link} to="/edycja-danych-firmy">
                                    <ListItemIcon>
                                        <FontAwesomeIcon aria-label={"Edycja-danych-firmy"} icon={faBuilding} />
                                    </ListItemIcon>
                                    <ListItemText primary="Edycja danych firmy" />
                                </MenuItem>}
                                {userModeState.userMode === false && <MenuItem onClick={handleClose} component={Link} to="/wiadomosci" disabled={!checkRolesPermissions(MessagesPagePermissions.accessRule)}>
                                    <ListItemIcon>
                                        <FontAwesomeIcon aria-label={"Wiadomości"} icon={faEnvelope} />
                                    </ListItemIcon>
                                    <ListItemText primary="Wiadomości" />
                                </MenuItem>}
                                <MenuItem onClick={handleClose} component={Link} to="/stanowiska-zwiazane">
                                    <ListItemIcon>
                                        <FontAwesomeIcon aria-label={"Documents"} icon={faUsers} />
                                    </ListItemIcon>
                                    <ListItemText primary="Stanowiska związane" />
                                </MenuItem>
                                <MenuItem onClick={handleClose} component={Link} to="/dokumenty-zwiazane">
                                    <ListItemIcon>
                                        <FontAwesomeIcon aria-label={"Documents"} icon={faCoins} />
                                    </ListItemIcon>
                                    <ListItemText primary="Dokumenty związane" />
                                </MenuItem>
                            </Menu>
                            <Button
                                className={classes.navBarButton}
                                aria-controls="customized-menu"
                                aria-haspopup='true'
                                color="inherit"
                                onClick={handlePluginMenuClick}
                            >
                                Rozszerzenia
                            </Button>
                            <Menu
                                id="menu-admin"
                                anchorEl={anchorPluginMenuEl}
                                getContentAnchorEl={null}
                                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                transformOrigin={{ vertical: "top", horizontal: "center" }}
                                open={Boolean(anchorPluginMenuEl)}
                                onClose={handleClosePluginMenu}
                            >
                                <MenuItem onClick={handleClosePluginMenu} component={Link} to="/plugins-management">
                                    <ListItemIcon>
                                        <FontAwesomeIcon aria-label={"fa-plug"} icon={faPlug} />
                                    </ListItemIcon>
                                    <ListItemText primary="Zarządzaj" />
                                </MenuItem>
                                {plugins && plugins.filter(plugin => {
                                    let result = true;
                                    if(plugin.roles.length > 0){
                                        result = false;
                                        const pluginRoles = plugin.roles.map(r => r.role);
                                        auth.getUserRoles().every(r => {
                                            if(pluginRoles.includes(r)) {
                                                result = true;
                                                return false;
                                            }
                                            return true;
                                        })
                                    }
                                    if(result && plugin.theme !== null) {
                                        if(plugin.theme === 1) {
                                            result = userModeState.userMode
                                        } else {
                                            result = !userModeState.userMode

                                        }
                                    }
                                    return result
                                }).map(p => (
                                    <MenuItem key={p.link} onClick={handleClosePluginMenu} component={Link} to={`/plugin-${p.link}`}>
                                        {p.icon && (
                                            <ListItemIcon>
                                                <i className={p.icon}></i>
                                            </ListItemIcon>
                                        )}
                                        <ListItemText primary={p.short_name} />
                                    </MenuItem>
                                ))}

								{process.env.NODE_ENV === "development" && (
									<>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-ocena-ryzyka`}>
											<ListItemIcon>
                                            <i className={"fas fa-user-friends"} />
											</ListItemIcon>
											<ListItemText primary={"Ocena ryzyka DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-rejestr-czynnosci`}>
											<ListItemIcon>
                                                <i className={"fas fa-cogs"} />
											</ListItemIcon>
											<ListItemText primary={"Rejestr Czynności DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-rejestr-czynnosci-ict`}>
											<ListItemIcon>
                                                <i className={"fas fa-server"} />
											</ListItemIcon>
											<ListItemText primary={"Rejestr Czynności ICT DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-mailer`}>
											<ListItemIcon>
                                                <i className={"fa fa-envelope"} />
											</ListItemIcon>
											<ListItemText primary={"Mailer DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-workflowinfo`}>
											<ListItemIcon>
                                                <i className={"fas fa-folder-open"} />
											</ListItemIcon>
											<ListItemText primary={"Workflowinfo DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-szkolenia`}>
											<ListItemIcon>
                                                <i className={"fas fa-chalkboard-teacher"} />
											</ListItemIcon>
											<ListItemText primary={"Szkolenia DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-importexport`}>
											<ListItemIcon>
                                                <i className={"fas fa-exchange-alt"} />
											</ListItemIcon>
											<ListItemText primary={"Import / Export DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-stats`}>
											<ListItemIcon>
                                                <i className={"fas fa-chart-bar"} />
											</ListItemIcon>
											<ListItemText primary={"Statystyki DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-download`}>
											<ListItemIcon>
                                                <i className={"fas fa-download"} />
											</ListItemIcon>
											<ListItemText primary={"Download DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-upowaznienia`}>
											<ListItemIcon>
												<i className={"fas fa-id-card"} />
											</ListItemIcon>
											<ListItemText primary={"Upoważnienia DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-workflowattachments`}>
											<ListItemIcon>
                                                <i className={"fas fa-qrcode"} />
											</ListItemIcon>
											<ListItemText primary={"Workflow - Załączniki DEV"} />
                                        </MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-logger`}>
											<ListItemIcon>
                                            <i className={"fas fa-bug"} />
											</ListItemIcon>
											<ListItemText primary={"Logger DEV"} />
										</MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-dfcmassprint`}>
											<ListItemIcon>
                                            <i className={"fas fa-bug"} />
											</ListItemIcon>
											<ListItemText primary={"MassPrint DEV"} />
                                        </MenuItem>
										<MenuItem onClick={handleClosePluginMenu} component={Link} to={`/dev-plugin-todolist`}>
											<ListItemIcon>
                                            <i className={"fas fa-bug"} />
											</ListItemIcon>
											<ListItemText primary={"TodoList DEV"} />
                                        </MenuItem>
									</>
								)}
							</Menu>
							{userModeState.userMode === false && (
								<>
									<Button
										className={classes.navBarButton}
										aria-controls="customized-menu"
										aria-haspopup="true"
										color="inherit"
										onClick={handleAdminMenuClick}
									>
										Administracja
									</Button>
									<Menu
										id="menu-admin"
										anchorEl={anchorAdminMenuEl}
										getContentAnchorEl={null}
										anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
										transformOrigin={{ vertical: "top", horizontal: "center" }}
										open={Boolean(anchorAdminMenuEl)}
										onClose={handleCloseAdminMenu}
									>
										<MenuItem
											onClick={handleCloseAdminMenu}
											component={Link}
											to="/uzytkownicy"
                                            disabled={!checkRolesPermissions(UsersPagePermissions.accessRule)}
										>
											<ListItemIcon>
												<GroupIcon />
											</ListItemIcon>
											<ListItemText primary="Użytkownicy" />
										</MenuItem>
										{"CMP_MAIN" === auth.getUserRole("CMP_MAIN") && (
											<MenuItem
												onClick={handleCloseAdminMenu}
												component={Link}
												to="/zarzadzanie-haslami"
                                                disabled={!checkRolesPermissions(PasswordManagmentPagePermissions.accessRule)}
											>
												<ListItemIcon>
													<FontAwesomeIcon aria-label={"Zarządzanie-Hasłami"} icon={faKey} />
												</ListItemIcon>
												<ListItemText primary="Zarządzanie hasłami" />
											</MenuItem>
										)}
                                        <MenuItem onClick={handleCloseAdminMenu} component={Link} to="/sledzenie-zmian">
                                            <ListItemIcon>
                                                <FontAwesomeIcon aria-label={"Sledzenie-Zmian"} icon={faEye} />
                                            </ListItemIcon>
                                            <ListItemText primary="Śledzenie zmian" />
                                        </MenuItem>
									</Menu>
								</>
							)}
                            <div className={classes.buttonLinkContainer}>
                                <span>Na skróty:</span>
                                {(auth.getUserRole("ADMIN") === "ADMIN" || auth.getUserRole("EDITOR") === "EDITOR") && (
                                    <Tooltip title="Przejdź do dokumentów w trybie edycji">
                                        <IconButton size="small" onClick={handleEditModeTree}>
                                            <img src={EditModeTree} className={classes.buttonLink} alt="Przejdź do trybu edycji" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip title="Przejdź do dokumentów w trybie użytkownika">
                                    <IconButton size="small" onClick={handleUserModeTree}>
                                        <img src={UserModeTree} className={classes.buttonLink} alt="Przejdź do trybu użytkownika" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Przejdź do procesów inicjowanych na stanowisku">
                                    <IconButton size="small" onClick={handleUserProcesses}>
                                        <img src={UserProcesses} className={classes.buttonLink} alt="Przejdź do procesów inicjowanych na stanowisku" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Przejdź do listy spraw">
                                    <IconButton size="small" onClick={handleUserDocuments}>
                                        <img src={UserDocuments} className={classes.buttonLink} alt="Przejdź do listy spraw" />
                                    </IconButton>
                                </Tooltip>
                            </div>
						</>
					)}
					{auth.getUserRole("G_ADMIN") === "G_ADMIN" && (
						<>
							<Button
								className={classes.navBarButton}
								aria-controls="customized-menu"
								aria-haspopup="true"
								color="inherit"
								component={Link}
								to="/edycja-danych-firmy"
							>
								Edycja danych firmy
							</Button>
							<Button
								className={classes.navBarButton}
								aria-controls="customized-menu"
								aria-haspopup="true"
								color="inherit"
								component={Link}
								to="/zarzadzanie-firmami"
							>
								Zarządzanie firmami podrzędnymi
							</Button>
							<Button
								className={classes.navBarButton}
								aria-controls="customized-menu"
								aria-haspopup="true"
								color="inherit"
								component={Link}
								to="/uzytkownicy"
							>
								Użytkownicy
							</Button>
						</>
					)}

					<div style={{ flexGrow: 1 }}></div>
					<Badge badgeContent={messageCounter} className={classes.badge} color="secondary" onClick={openMessageComponent}>
						<MessageIcon />
					</Badge>
					<Avatar id="menu-user" className={classes.avatar} aria-haspopup="true" color="inherit" onClick={handleUserMenuClick} />
					<Menu
						anchorEl={anchorUserMenuEl}
						getContentAnchorEl={null}
						anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
						transformOrigin={{ vertical: "top", horizontal: "center" }}
						open={Boolean(anchorUserMenuEl)}
						onClose={handleCloseUserMenu}
					>
						{auth.getUserRole("G_ADMIN") !== "G_ADMIN" && (auth.getUserRole("ADMIN") === "ADMIN" || auth.getUserRole("EDITOR") === "EDITOR") && (
							<MenuItem onClick={handleUserMode}>
								<ListItemIcon>
									<FontAwesomeIcon aria-label={"user-mode"} icon={faTools} />
								</ListItemIcon>
								{userModeState.userMode === true ? (
									<ListItemText primary="Włącz tryb edycji" />
								) : (
									<ListItemText primary="Włącz tryb użytkownika" />
								)}
							</MenuItem>
						)}
						<MenuItem id="menu-change-password" onClick={handleChangePassword} disabled={auth.isDomainUser()}>
							<ListItemIcon>
								<FontAwesomeIcon icon={faUnlock} />
							</ListItemIcon>
							<ListItemText primary="Zmień hasło" />
						</MenuItem>
						<MenuItem
							id="menu-user-logout"
							onClick={() => {
								handleLogout();
							}}
						>
							<ListItemIcon>
								<ExitToAppIcon />
							</ListItemIcon>
							<ListItemText primary="Wyloguj" secondary={auth.getUserName()} />
						</MenuItem>
					</Menu>
				</CustomToolBar>
			</AppBar>
			<PasswordChangeDialogComponent ref={changePasswordDialogRef} />
		</>
	);
};

const NaviBarWithSocket = (props) => (
    <SocketContext.Consumer>
        {socket => <NaviBar {...props} socket={socket} />}
    </SocketContext.Consumer>
);

export default NaviBarWithSocket;